import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { cloneDeep, get, isEmpty, uniqueId } from 'lodash';

import { Listings } from 'containers/AppContainer/typings';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import JudgementAddForm from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/JudgementAddForm';
import { EMPTY_ADD } from 'containers/data-structure';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Forms } from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/styled-components';
import JudgementAddPronouncingRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/JudgementAddPronouncingRecapAccordion';
import { isDuplicateJudgementsAdd } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import { translate } from 'containers/services/translate';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';
import { VictimType } from 'typings/globalTypes';

export interface JudgementAddPronouncingFormsProps {
  intl: IntlShape;
  listings: Listings;
  victims: VictimType[];
  vehicules: Vehicule[];
  judgementAddDocuments: JudgementADDDocumentType[];
  setJudgementAddDocuments: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  details: any;
  resetUploadedDocument: Function;
  setIsAddJudgementAddFormOn: React.Dispatch<React.SetStateAction<boolean>>;
  judiciaryProcessId?: number;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  claimAssignment: any;
  feeNotes: any;
  isBasicManagement?: boolean;
  imagineDocuments: any;
  policyInfo: any;
  claimId: number;
  requestGetDocByDocumentumId: Function;
}

const JudgementAddPronouncingForms: React.FC<JudgementAddPronouncingFormsProps> = (
  props,
): JSX.Element => {
  const [judgementAddPronouncings, setJudgementAddPronouncings] = useState<
    JudgementADDDocumentType[]
  >(
    !isEmpty(props.judgementAddDocuments) && props.isBasicManagement
      ? []
      : ([cloneDeep(EMPTY_ADD)] as any),
  );

  const handleChangeJudgementAddProunoucing = (index: number) => (
    judgement: JudgementADDDocumentType,
  ) => {
    const judgementADD = [...judgementAddPronouncings];
    if (!isEmpty(judgement)) {
      judgementADD[index] = judgement;
    } else {
      //handling the case when emptying state
      judgementADD.splice(index, 1);
    }

    setJudgementAddPronouncings(judgementADD);
  };

  const [showDuplicateWarning, setShowDuplicateWarning] = useState<boolean>(
    false,
  );
  const [
    openInvoiceFeeNoteUpdateInfoDialog,
    setOpenInvoiceFeeNoteUpdateInfoDialog,
  ] = useState<boolean>(false);

  const saveForm = (judgement: JudgementADDDocumentType) => {
    if (isDuplicateJudgementsAdd(judgement, props.judgementAddDocuments)) {
      return setShowDuplicateWarning(true);
    }
    const judgementADDDocuments = [...props.judgementAddDocuments];
    judgementADDDocuments.push(judgement);
    props.setJudgementAddDocuments(
      props.isBasicManagement
        ? judgementADDDocuments.map((el: any) => {
            return {
              ...el,
              expertises: [
                ...get(el, 'expertises', []).map((el: any) => {
                  const genId = uniqueId();
                  return {
                    ...el,
                    victims: el.victims.map((victim: any) => {
                      return {
                        ...victim,
                        expertiseJudgementAddDocumentId: genId,
                      };
                    }, []),
                    expertiseJudgementAddDocumentId: genId,
                  };
                }),
              ],
            };
          })
        : judgementADDDocuments,
    );
    setShowDuplicateWarning(false);
  };

  const deleteJudgementAdd = (index: number) => () => {
    const judgementAddDocs = [...props.judgementAddDocuments];

    if (judgementAddDocs.length <= 1 && isEmpty(judgementAddPronouncings)) {
      props.setIsAddJudgementAddFormOn(false);
    }

    judgementAddDocs.splice(index, 1);
    props.setJudgementAddDocuments(judgementAddDocs);
  };

  const cancelJudgement = (index: number) => () => {
    let judgement = [...judgementAddPronouncings];

    if (
      isEmpty(props.judgementAddDocuments) &&
      judgementAddPronouncings.length === 1
    ) {
      props.setIsAddJudgementAddFormOn(false);
    } else {
      judgement.splice(index, 1);
      setJudgementAddPronouncings(judgement);
    }
  };
  return (
    <Forms>
      <div
        style={{
          margin: '5px',
          fontWeight: 'bold',
          fontSize: '18px',
          color: 'red',
        }}
      >
        {showDuplicateWarning
          ? translate(messages.duplicateJaddWarning, props)
          : ''}
      </div>
      {!isEmpty(props.judgementAddDocuments) &&
        props.judgementAddDocuments.map(
          (judgementAddDocument, index: number) => {
            return (
              <JudgementAddPronouncingRecap
                key={uniqueId('recap_')}
                listings={props.listings}
                judgementAddDocument={judgementAddDocument}
                index={index}
                deleteJudgementAdd={deleteJudgementAdd(index)}
                isManager={false}
                judiciaryProcessId={props.judiciaryProcessId}
                sagisVictimInfo={props.sagisVictimInfo}
                sagisOpposingParties={props.sagisOpposingParties}
                claimAssignment={props.claimAssignment}
                feeNotes={props.feeNotes}
                setOpenFeeNoteDialog={() => {}}
                isBasicManagement={props.isBasicManagement}
                policyInfo={props.policyInfo}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
                resetUploadedDocument={props.resetUploadedDocument}
                uploadDocument={props.uploadDocument}
                uploadedDocument={props.uploadedDocument}
                openInvoiceFeeNoteUpdateInfoDialog={
                  openInvoiceFeeNoteUpdateInfoDialog
                }
                setOpenInvoiceFeeNoteUpdateInfoDialog={
                  setOpenInvoiceFeeNoteUpdateInfoDialog
                }
                setJudgemenAddDocumentToUpdate={() => {}}
                handleValidateUpdateJudgementAddDocument={() => {}}
              />
            );
          },
        )}
      {!isEmpty(judgementAddPronouncings) &&
        judgementAddPronouncings.map((judgement: any, index: number) => (
          <JudgementAddForm
            key={index}
            listings={props.listings}
            victims={props.victims}
            details={props.details}
            judgementAddPronouncing={judgement}
            vehicules={props.vehicules}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            resetUploadedDocument={props.resetUploadedDocument}
            handleSetJudgementAddPronouncing={handleChangeJudgementAddProunoucing(
              index,
            )}
            index={index}
            saveForm={saveForm}
            cancelJudgement={cancelJudgement(index)}
            sagisVictimInfo={props.sagisVictimInfo}
            sagisOpposingParties={props.sagisOpposingParties}
            isBasicManagement={props.isBasicManagement}
            imagineDocuments={props.imagineDocuments}
            policyInfo={props.policyInfo}
            claimId={props.claimId}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        ))}
    </Forms>
  );
};

export default injectIntl(JudgementAddPronouncingForms);
